"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const NoEye = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M3.035 3.978l-2.84-2.84a.667.667 0 0 1 .943-.943l2.98 2.98C5.3 2.423 6.595 2 8 2c2.253 0 4.226 1.088 5.903 2.877.576.615 1.077 1.271 1.5 1.928.257.397.433.71.527.897a.667.667 0 0 1 0 .596c-.094.188-.27.5-.526.897a13.661 13.661 0 0 1-1.501 1.928c-.303.323-.616.624-.938.899l2.84 2.84a.667.667 0 1 1-.943.943l-2.98-2.98C10.7 13.577 9.405 14 8 14c-2.253 0-4.226-1.088-5.903-2.877a13.661 13.661 0 0 1-1.5-1.928C.34 8.798.163 8.485.07 8.298a.667.667 0 0 1 0-.596c.094-.188.27-.5.526-.897.424-.657.925-1.313 1.501-1.928.303-.323.616-.624.938-.899zm2.668 2.667a2.667 2.667 0 0 0 3.652 3.652L5.703 6.645zm.942-.942l3.652 3.652a2.667 2.667 0 0 0-3.652-3.652z"
}));
var _default = exports.default = NoEye;